import React from "react";
import "./App.css";
import { Authenticator, Card, ThemeProvider } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import { Amplify } from "aws-amplify";
import OrdersReport from "./components/OrdersReport";

import awsExports from "./aws-exports";

Amplify.configure(awsExports);

const App = () => {
  return (
    <Authenticator hideSignUp>
      {({ signOut, user }) => (
        <ThemeProvider>
          <Card variation="outlined">
            <OrdersReport />
          </Card>
        </ThemeProvider>
      )}
    </Authenticator>
  );
};

export default App;
